<template>
  <div class="pagemain">

    <div class="form-group">
      <div class="form-group-content">
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="貨幣">
              <div style="display: flex;">
                <div style="margin-right: 10px;"><img class="currencyimg" src="~@/assets/0.png"></div>
                <div>HKD 港幣</div>
              </div>
            </el-form-item>

          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="賬戶代號" prop="code">
              <el-input v-model="form.code"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="賬戶號碼" prop="account_num">
              <el-input v-model="form.account_num_format" @input="cardformat()" @change="cardformat" ref="cardInput" clearable></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="賬戶戶名" prop="account_name">
              <el-input v-model="form.account_name"></el-input>
            </el-form-item>

          </div>
          <div class="mm-col ml-20">
            <el-button @click="openchooseholder">使用戶主名稱</el-button>
            <el-dialog @closed="closechooseholder" title="導入戶主名稱" :visible.sync="chooseholder" width="95%" :append-to-body="true">
              <component @closeholder="closeholder" :is="chooseholder_component"></component>
            </el-dialog>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="銀行名稱" prop="bankname">
              <hkbankselect :form="form"></hkbankselect>
            </el-form-item>
          </div>
          <div class="mm-col ml-20">
            <el-input v-model="form.bankinfo"></el-input>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="銀行代碼" prop="bankcode">
              <el-input v-model="form.bankcode"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="備註信息" prop="mark">
              <el-input v-model="form.mark"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <el-form-item label="使用狀態">
            <el-switch v-model="form.status" active-text="啟用" inactive-text="禁用">
            </el-switch>
          </el-form-item>

        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="餘額" prop="balance">
              <el-input v-model="form.balance" disabled=""></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="單日限額" prop="day_limit">
              <el-input v-model="form.day_limit"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="單月限額" prop="day_limit">
              <el-input v-model="form.month_limit"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="30日限額" prop="day_limit">
              <el-input v-model="form.limit_30"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-col">
            <el-form-item label="創建日期" prop="addtime">
              <el-date-picker v-model="form.addtime" type="date" placeholder="選擇日期" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import hkbankselect from '@/components/HKBankSelect.vue';
import chooseholder from './ChooseHolder.vue';
export default {
  components: {
    hkbankselect,
    chooseholder
  },
  props: ['form'],
  data () {
    return {
      loading: false,
      chooseholder: false,
      chooseholder_component: '',
      hkBankList: [],
      hkBankListBF: [],
    };
  },
  methods: {
    cardformat () {
      let val = this.form.account_num_format;
      this.formatCardNumber(this.form, val);
    },
    pageback () {
      this.$router.go(-1);
    },
    closeholder (holder) {

      this.chooseholder = false;
      this.chooseholder_component = '';
      this.form.account_name = holder.name;

    },
    closechooseholder () {
      this.chooseholder = false;
      this.chooseholder_component = '';
    },
    openchooseholder () {
      this.chooseholder = true;
      this.chooseholder_component = chooseholder;
    },
    // 獲取香港銀行列表
    getHKBanksList () {
      this.post('/api/bank/hkbanks', { page: 1, size: 1000, condition: '' })
        .then(response => {
          this.hkBankListBF = response;
          let hkBankList = response;
          this.hkBankList = hkBankList.map(item => {
            return { value: `${item.id}`, label: `${item.twname}(${item.code})` };
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

  },
  created () {
    this.getHKBanksList();
    this.form.currency_id = 2;
    // console.log(this.form);
  },
  watch: {
    'form.account_num_format' (val) {
      if (val) {
        this.form.account_num = this.mytrim(val);
      }else{
        this.form.account_num = '';
      }
    },
    'form.hkbank_id' (val) {
      console.log(val);
      this.hkBankListBF.some(item => {
        if (item.id == val) {
          this.form.bankname = this.form.bankinfo = item.twname;
        }
      })
    },
    'form.bankinfo' (val) {
      this.form.bankname = this.form.bankinfo;
    },
  }
};
</script>


<style scoped>
.mm-row {
}

.currencyimg {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: block;
}
.ml-20 {
  margin-left: 20px;
}
@media screen and (max-width: 1024px) {
  .mm-row {
    width: 100%;
    display: block;
  }
  .ml-20 {
    margin: 0;
  }
}
</style>
